module.exports = __WEBPACK_EXTERNAL_MODULE_153__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/observable/empty","commonjs2":"rxjs/add/observable/empty","amd":"rxjs/add/observable/empty"}
// module id = 153
// module chunks = 0 1